import { module } from 'modujs';
import { $html } from '../utils/dom'
import * as focusTrap from 'focus-trap';

const CLASS = {
    OPEN: `has-modal-help-open`,
}

export default class extends module {
    constructor(m) {
        super(m);
        this.canOpen = true;
    }

    ///////////////
    // Lifecyle
    ///////////////
    init() {
      //  this.bindEvents()
        this.focusTrap = focusTrap.createFocusTrap([this.el, '.c-header'], {
            onDeactivate: this.closeModal.bind(this),
            clickOutsideDeactivates: true,
        });
    }

    ///////////////
    // Callbacks
    ///////////////
    toggle() {
        if($html.classList.contains(CLASS.OPEN)) {
            this.closeModal();
            this.call('closeModal', null, 'Header')
        }
        else {
            this.openModal();
            this.call('openModal', null, 'Header')
        }
    }

    openModal() {
        if(!this.canOpen) return;

        $html.classList.add(CLASS.OPEN)
        this.el.scrollTo(0, 0);
        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                this.focusTrap?.activate()
            })
        })
    }

    closeModal() {
        this.canOpen = false;
        setTimeout(() => {
            this.canOpen = true;
        }, 250);

        $html.classList.remove(CLASS.OPEN)
        this.focusTrap?.deactivate()
    }
}
